<template>
 <div id="list">
  <dd-header></dd-header>
  <!-- 上部タブ -->
  <div class="container_main">
    <!-- 左部サイドバー -->
    <nav class="sidebar_left">
      <div class="side_menu">
        <section>
            <ul>
              <li>
                <a class="list_name" @click="showOutputList" :class="{ 'active': isOutputList }">
                  <span>●</span>出力物リスト
                </a>
              </li>
            </ul>
        </section>
      </div>
    </nav>
    <!--  メインコンテンツ  -->
    <main :style="{width: getMainWidth()}">
      <dd-output-table
      ref="OutputTableRef"
      :isOutputList="isOutputList"
      />
    </main>
  </div>
  <dd-footer />
 </div>
</template>
<script>
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
import OutputTable from '../components/output/OutputTable'
export default {
  name: 'Output',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-output-table': OutputTable
  },
  data () {
    return {
      /** 出力物リスト表示フラグ */
      isOutputList: false
    }
  },
  computed: {
  },
  methods: {
    /** 営業管理テーブル表示 */
    showOutputList: function () {
      this.isOutputList = true
      this.$refs.OutputTableRef.getOutputList()
    },
    /** main要素の幅を取得 */
    getMainWidth: function () {
      if (this.isDispSideTab) {
        return 'calc(100% - 240px)'
      } else {
        return '100%'
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    this.showOutputList()
  }
}
</script>
<style src="../css/list/list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/Output.vue